import React from 'react';

function Moldova(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124064)">
        <mask
          id="mask0_800_124064"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124064)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.75 0H36V24H24.75V0Z"
            fill="#D9071E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H13.5V24H0V0Z"
            fill="#3D58DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.25 0H24.75V24H11.25V0Z"
            fill="#FBCD17"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4332 19.6142L23.2485 20.1895L19.3216 13.8007L20.5063 13.2254L24.4332 19.6142ZM11.8276 19.7678L13.0123 20.3431L16.9392 13.9543L15.7545 13.379L11.8276 19.7678Z"
            fill="#FD1900"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8002 9.38903V14.9403C12.8002 16.1735 11.6056 17.7807 11.0032 18.3786C10.4007 18.9764 9.2041 20.3462 9.2041 20.3462V5.40832C9.2041 3.73275 11.0032 3.15717 11.0032 3.15717C11.0032 3.15717 12.497 3.41987 12.8002 5.40832V7.34626C13.2625 7.66988 14.8065 8.66253 15.8039 8.24351C16.9881 7.746 17.3971 6.31905 17.3971 6.31905C17.3971 6.31905 17.2864 4.87916 16.8003 4.87916C16.3142 4.87916 16.2754 2.85088 18.1369 2.85088C19.9983 2.85088 20.2153 3.6327 20.2153 4.25593C20.2153 4.58262 19.9207 5.10691 19.6403 5.60584C19.3858 6.05871 19.1431 6.49069 19.1431 6.73501C19.1431 7.2485 19.5784 8.24351 20.2153 8.24351C20.662 8.24351 22.8104 7.50155 24.054 7.05834V5.40832C24.3573 3.41987 25.8511 3.15717 25.8511 3.15717C25.8511 3.15717 27.6501 3.73275 27.6501 5.40832V20.3462C27.6501 20.3462 26.4536 18.9764 25.8511 18.3786C25.2486 17.7807 24.054 16.1735 24.054 14.9403V9.38903H12.8002ZM14.7938 19.8322C16.0106 19.128 17.7905 15.9701 17.7905 15.9701L18.3815 16.0922C18.3815 16.0922 19.2838 18.1838 21.9369 19.8322C19.1089 20.503 18.3815 21.8501 18.3815 21.8501C18.3815 20.7725 14.7938 19.8322 14.7938 19.8322ZM14.5979 17.8333C15.418 17.8333 16.0829 17.2737 16.0829 16.5833C16.0829 15.893 15.418 15.3333 14.5979 15.3333C13.7777 15.3333 13.1129 15.893 13.1129 16.5833C13.1129 17.2737 13.7777 17.8333 14.5979 17.8333ZM23.3098 16.5833C23.3098 17.2737 22.645 17.8333 21.8248 17.8333C21.0047 17.8333 20.3398 17.2737 20.3398 16.5833C20.3398 15.893 21.0047 15.3333 21.8248 15.3333C22.645 15.3333 23.3098 15.893 23.3098 16.5833Z"
            fill="#A77B3B"
          />
          <path
            d="M28.2827 10.4076L29.3154 10.8044L25.1084 19.4563L24.0757 19.0596L28.2827 10.4076Z"
            fill="#FDFF00"
          />
          <path
            opacity="0.3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4199 7.83334H24.2999V15.4722C24.2999 15.4722 21.2769 16.2816 18.3599 17.6097C16.2066 16.1898 12.4199 15.4722 12.4199 15.4722V7.83334Z"
            fill="#E1E5E8"
          />
          <mask
            id="mask1_800_124064"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="12"
            y="7"
            width="13"
            height="11"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.4199 7.83334H24.2999V15.4722C24.2999 15.4722 21.2769 16.2816 18.3599 17.6097C16.2066 16.1898 12.4199 15.4722 12.4199 15.4722V7.83334Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124064)">
            <rect
              x="12.4199"
              y="12.8333"
              width="11.88"
              height="5"
              fill="#3D58DB"
            />
            <rect
              x="12.4199"
              y="7.83334"
              width="11.88"
              height="5"
              fill="#FD1900"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.7601 10.0821L16.8597 10.1484L17.379 9.52571L16.8256 8.88087L17.7306 8.98445L18.0776 8.27337L18.4633 8.9996L19.3636 8.93337L18.8444 9.55602L19.3977 10.2009L18.4928 10.0973L18.1458 10.8084L17.7601 10.0821Z"
              fill="#FDFF00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.1436 8.67169C16.1436 8.67169 13.7249 9.97968 14.5311 10.9186C15.3374 11.8576 16.3522 11.9777 16.3522 11.9777C16.3522 11.9777 13.8781 15.277 18.2326 17.1619C22.8946 15.3423 20.4429 11.9777 20.4429 11.9777C20.4429 11.9777 21.8779 11.6955 22.1653 10.6803C22.4526 9.66509 20.2895 8.50066 20.2895 8.50066C20.2895 8.50066 21.6391 10.2395 21.331 10.6803C21.0229 11.1212 19.3724 11.57 18.2326 11.57C17.0929 11.57 15.3329 11.2855 15.0489 10.5152C14.7649 9.74484 16.1436 8.67169 16.1436 8.67169Z"
              fill="#FDFF00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.9049 12L15.3899 12.8333L13.9049 13.6667L12.4199 12.8333L13.9049 12Z"
              fill="#FDFF00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.8151 12L24.3001 12.8333L22.8151 13.6667L21.3301 12.8333L22.8151 12Z"
              fill="#FDFF00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.8602 15.3C14.1087 15.3 14.3102 15.1209 14.3102 14.9C14.3102 14.6791 14.1087 14.5 13.8602 14.5C13.6116 14.5 13.4102 14.6791 13.4102 14.9C13.4102 15.1209 13.6116 15.3 13.8602 15.3Z"
              fill="#FDFF00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.4338 14.5428C23.0475 14.2647 22.4554 14.3455 22.1113 14.7232C21.7672 15.1009 21.8014 15.6325 22.1877 15.9106C22.3977 16.0617 22.2881 15.4612 22.6059 15.0792C22.8728 14.7583 23.6101 14.6697 23.4338 14.5428Z"
              fill="#FDFF00"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32886 11.529C5.32886 11.529 6.51475 12.7752 7.63138 12.3677C8.74802 11.9603 8.47729 10.4995 8.47729 10.4995L7.63138 11.1816H6.91131V11.529L6.34893 11.1816V11.529H5.32886ZM6.13091 13.444C6.13091 13.444 7.57629 14.5646 8.55008 14.2479C9.52387 13.9313 9.27934 12.4145 9.27934 12.4145L8.43343 13.0966H7.71336V13.444L7.15097 13.0966V13.444H6.13091ZM10.0232 15.9869C9.04942 16.3036 7.60403 15.183 7.60403 15.183H8.6241V14.8356L9.18649 15.183V14.8356H9.90656L10.7525 14.1535C10.7525 14.1535 10.997 15.6703 10.0232 15.9869Z"
            fill="#048F02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7268 2.24849H14.6018V2.84408H14.0723V3.84408H14.6018V5.58871H15.7268V3.84408H16.3705V2.84408H15.7268V2.24849Z"
            fill="#FDFF00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0529 3.38455L14.4473 3.9812L17.0529 4.71308V3.38455Z"
            fill="#DB4400"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124064">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Moldova;
